import React from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useContext } from "react";
import { locationContext } from "../../Context/CustomContext";

export const CustomBreadcrumbs = () => {
  const { currentLocation } = useContext(locationContext);
  const pathMaps = {
    "/getallpipelines": "List Screen - Pipelines",
    "/getalllookupdata": "List Screen - Lookup",
    "/edit-pipeline": "Edit-Pipeline",
    "/edit-lookup": "Edit-Lookup",
  };

  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href={"/"}>
          Home
        </Link>
        {currentLocation
          ?.split("/")
          .slice(1, -1)
          .map((path, index) => (
            <Link
              key={index}
              underline="hover"
              color="inherit"
              href={"/" + path}
            >
              {pathMaps["/" + path]}
            </Link>
          ))}

        {currentLocation
          ?.split("/")
          .slice(-1)
          .map((path, index) => (
            <Link
              key={index}
              underline="hover"
              color="secondary"
              href={"/" + path}
            >
              {pathMaps["/" + path]}
            </Link>
          ))}
      </Breadcrumbs>
    </div>
  );
};
